module.exports = __webpack_public_path__ + "static/media/triangle-white.8515cbb0.svg";